import { useEffect, useState } from "react";
import { Dimmer, Loader, Image } from "semantic-ui-react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import moment from 'moment';
import { logout } from "actions/authentication";
import { Warning } from "components/atoms/Warning/Warning";
import "./_Account.scss";
import { getUserProfile } from "actions/user";
import { Button } from "components/atoms/Button/Button";

const Account = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [profile, setProfile] = useState([]);
  const [subExpired, setSubExpired] = useState(false);

  const logOutAndReturn = () => {
    dispatch(logout());
  };

  useEffect(() => {
    const fetchProfile = async () => {
      const profile = await dispatch(getUserProfile());
      if(profile) {
      setProfile(profile);
      setIsLoading(false);
      setSubExpired(moment(new Date()).isAfter(profile.subscriptionEnds));
      } else {
        dispatch(logout());
      }
    };
    fetchProfile();
  }, []);

  return (
    <div className="pa2 account">
      {isLoading && 
        <Dimmer active inverted>
          <Loader inverted>Loading Account page</Loader>
        </Dimmer> }
        <div className="flex flex-column h-100 mb2 justify-between items-center account__container relative">
          <a href="https://www.boldreuse.com/">
            <h4 className='account__container--return'>Return to Bold Reuse</h4></a>
          <Image src={process.env.REACT_APP_LOGO} alt='logo' size='small' />
          {subExpired
            && (
              <div className='account__warning'>
                <Warning>
                  <p>Your Bold Reuse subscription has expired. Renew it <Link to='/renew'>here.</Link></p>
                </Warning>
              </div>
            )}
          <h2 className="center account__container--title">My Account</h2>
          <div className="account__container--email">{profile?.email}</div>
          <h3 className='account__container--description'>My Bold Reuse subscription</h3>
          <div className="flex flex-column justify-between items-center account__details">
            <div className='flex mv1 items-start'><span className='account__details--title'>Subscription: </span> 
              <span className='account__details--data'>
                {profile.subscriptionPlan ? !subExpired ? `${profile?.subscriptionPlan} with ${profile?.subscriptions} credit${profile.subscriptions > 1 ? 's' : ''}` : 'Expired' : 'No plan'} 
              </span>
            </div>
            <div className='flex mv1 items-center'><span className='account__details--title'>Subscription Renew Date: </span>
              <span className='account__details--data'>{subExpired || isLoading ? '-' 
              : new Date(profile.subscriptionEnds).toLocaleDateString('en-GB', {
                month : 'long',
                day : 'numeric',
                year : 'numeric'
                })}
              </span> 
            </div>
            <div className='flex mv1 items-center'><span className='account__details--title'>Card on File: </span> <span className='account__details--data'>{!subExpired ? `${profile?.cardType ? `${profile?.cardType} ending in ${profile?.cardLast4}` : ''}` : '-' }</span></div>
            <div className='account__details--separator'/>
            <div className='flex mv1 items-center'><span className='account__details--title'>Credits available: </span> <span className='account__details--data'>{!subExpired ? profile?.tokens || '-' : '-'}</span></div>
            <div className='flex mv1 items-center'><span className='account__details--title'>Credits in use: </span> <span className='account__details--data'>{profile?.boxes || 0}</span></div>
            <div className='flex mv1 items-center'><span className='account__details--title'>Reusables checked out: </span> <span className='account__details--data'>{(profile?.numOfUses + profile?.boxes) || 0}</span></div>
            <div className='flex mv1 items-center'><span className='account__details--title'>Single-Use Products Eliminated: </span> <span className='account__details--data'>{profile?.numOfUses || 0}</span></div>
          </div>
          <div className="account__actions">
            {subExpired
              ? (
                <Link to='/renew' >
                  <Button text='Renew my subscription' className='primary' />
                </Link>)
              : (
                <a href={profile?.url} >
                  <Button text='Manage my subscription' className='primary' />
                </a>
              )}
          </div>
          <h4 className='account__container--logout' onClick={() => logOutAndReturn()}>Log out</h4>
        </div>
    </div>
  );
};

export default Account;
